import {
  CustomFetchClient,
  getConfigWithMetadata
} from "./chunk-NFLWKIRZ.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";
import {
  panic
} from "./chunk-KKRZEVOT.js";
import {
  AI_CHAT_BOT_ENV_URL_MAP
} from "./chunk-5IRT6RWL.js";

// generated/ai-chat-bot/custom-instance.ts
var customInstance = async (config, apiConfig) => {
  if (!apiConfig?.applicationKey) {
    panic("x-application-key is required");
  }
  const client = new CustomFetchClient({
    defaultBaseURL: AI_CHAT_BOT_ENV_URL_MAP[apiConfig?.environment ?? "prod"],
    defaultMaxRetryCount: 3,
    defaultRetryDelayMs: 250,
    defaultRetryStatusCodes: [429]
  });
  return client.request(config, apiConfig);
};

// generated/ai-chat-bot/controllers/ai-chatbot/ai-chatbot.ts
var message = (chatbotRequest, options) => {
  return customInstance(
    {
      url: `/api/v1/ai-chatbot/message`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: chatbotRequest
    },
    options
  );
};

// src/services/messageChatbot/messageChatbot.ts
var messageChatbot = async (chatbotRequest, apiConfig) => {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, "messageChatbot");
    const data = await message(chatbotRequest, _apiConfig);
    return {
      status: "success",
      data
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
};

export {
  messageChatbot
};
